import { useEffect, useState } from 'react';

/**
 * Wall-clock time, refreshed once a second. Display-only — never triggers a
 * refetch by itself; callers watching for a countdown crossing zero should
 * react to the returned timestamp explicitly.
 */
export function useNow(intervalMs = 1_000): number {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), intervalMs);
        return () => clearInterval(id);
    }, [intervalMs]);

    return now;
}
